export default __webpack_public_path__ + "static/martina-plantijn-web-italic-aea03ff57c1a8a2fd43cdcdd3c96df33.woff2";